import React from "react";
import { TableAction, TableControlsState, TableMenuType } from "./types";
import "./NoteTableControls.css";

interface NoteTableControlsProps {
    controls: TableControlsState;
    onToggleMenu: (menu: TableMenuType) => void;
    onTableAction: (action: TableAction) => void;
}

export const NoteTableControls: React.FC<NoteTableControlsProps> = ({
    controls,
    onToggleMenu,
    onTableAction,
}) => {
    if (!controls.visible) return null;

    return (
        <div className="note-table-controls" aria-label="Table controls">
            <button
                type="button"
                className={`note-table-handle ${controls.menu === "row" ? "active" : ""}`}
                aria-label="Row options"
                title="Row options"
                style={{ top: controls.rowTop, left: controls.rowLeft }}
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => onToggleMenu(controls.menu === "row" ? null : "row")}
            >
                ...
            </button>
            <button
                type="button"
                className={`note-table-handle ${controls.menu === "column" ? "active" : ""}`}
                aria-label="Column options"
                title="Column options"
                style={{ top: controls.columnTop, left: controls.columnLeft }}
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => onToggleMenu(controls.menu === "column" ? null : "column")}
            >
                ...
            </button>
            {controls.menu === "row" && (
                <div
                    className="note-table-menu note-table-row-menu"
                    style={{ top: controls.rowTop, left: controls.rowLeft - 18 }}
                >
                    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onTableAction("addRowAbove")}>Add row above</button>
                    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onTableAction("addRowBelow")}>Add row below</button>
                    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onTableAction("deleteRow")}>Delete row</button>
                </div>
            )}
            {controls.menu === "column" && (
                <div
                    className="note-table-menu note-table-column-menu"
                    style={{ top: controls.columnTop + 24, left: controls.columnLeft }}
                >
                    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onTableAction("addColumnBefore")}>Add column before</button>
                    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onTableAction("addColumnAfter")}>Add column after</button>
                    <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => onTableAction("deleteColumn")}>Delete column</button>
                </div>
            )}
        </div>
    );
};
